module.exports = __webpack_public_path__ + "res/32-img_game_top_bg_m.6135ee12840d59956e3ab3cc78adfa7a.png";